import React from "react";
import {withNamespaces} from "react-i18next";
import {Link, useLocation} from "react-router-dom";
import {
    defaultPlatformNewsPath,
    platformNewsCatalog,
} from "../../content/platform-news";
import {
    useCurrentUserPlatformNewsReadState,
} from "../../presentation/platform-news/use-current-user-platform-news-read-state";
import {
    isPlatformNewsPath,
} from "../../presentation/public-site/route-policy";

function PlatformNewsLink({
                              className = "",
                              onClick,
                              t,
                          }) {
    const location = useLocation();
    const isNewsPage = isPlatformNewsPath(
        location.pathname
    );

    const {
        userId,
        isRead,
    } = useCurrentUserPlatformNewsReadState();

    const hasUnreadNews = Boolean(
        userId &&
        platformNewsCatalog.some(
            (newsItem) => !isRead(newsItem.id)
        )
    );

    const linkLabel = t(
        "main.header.landingNavigation.news"
    );

    const linkClassName = [
        className,
        isNewsPage ? "is-active" : "",
    ].filter(Boolean).join(" ");

    return (
        <Link
            className={linkClassName}
            to={defaultPlatformNewsPath}
            onClick={onClick}
            aria-current={
                isNewsPage
                    ? "page"
                    : undefined
            }
            aria-label={
                hasUnreadNews
                    ? `${linkLabel}. ${t(
                        "main.newsPage.hasUnread"
                    )}`
                    : linkLabel
            }
            title={
                hasUnreadNews
                    ? t("main.newsPage.hasUnread")
                    : undefined
            }
        >
            <span>{linkLabel}</span>

            {hasUnreadNews && (
                <span
                    className="platform-news-link__unread-indicator"
                    aria-hidden="true"
                />
            )}
        </Link>
    );
}

export default withNamespaces("translation")(
    PlatformNewsLink
);
